import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import AreasOfFocus from "./pages/AreasOfFocus";
import Events from "./pages/Events";
import Publications from "./pages/Publications";
import Article from "./pages/Article";
import AdvisoryBoard from "./pages/AdvisoryBoard";
import Contact from "./pages/Contact";
import Donate from "./pages/Donate";
import Login from "./pages/admin/Login";
import Admin from "./pages/admin/Admin";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/areas-of-focus" element={<AreasOfFocus />} />
              <Route path="/events" element={<Events />} />
              <Route path="/publications" element={<Publications />} />
              <Route path="/publications/:slug" element={<Article />} />
              <Route path="/advisory-board" element={<AdvisoryBoard />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/donate" element={<Donate />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
